var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceiptIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon receipt",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.352 3.087c2.215.6 4.432.041 6.648-.524 2.417-.616 4.833-1.232 7.25-.33A1.2 1.2 0 0 1 16 3.376v8.61a1.048 1.048 0 0 1-1.353.928c-2.214-.606-4.431-.042-6.647.522-2.442.617-4.858 1.233-7.251.331A1.2 1.2 0 0 1 0 12.619V4.014a1.047 1.047 0 0 1 1.352-.927zm6.623 7.58a2.485 2.485 0 0 0 2.247-2.691 2.476 2.476 0 0 0-2.247-2.667 2.492 2.492 0 0 0-2.222 2.667 2.5 2.5 0 0 0 2.222 2.691zm-6.222 1.777h1.778a1.763 1.763 0 0 0-1.778-1.778zm0-7.581v1.778a1.747 1.747 0 0 0 1.778-1.778zm12.469 4.444a1.8 1.8 0 0 0-1.778 1.8h1.778zm-1.778-5.778a1.764 1.764 0 0 0 1.778 1.778V3.531z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptIcon);
export default __webpack_public_path__ + "static/media/receipt-icon.da215e26f90bfa21b0936f7cd3fa8d99.svg";
export { ForwardRef as ReactComponent };